<template>
  <a class="action-button"
     href="javascript:;">
    <i :class="`${icon}`"></i>
  </a>
</template>

<script>
export default {
  name: 'ActionButton',
  props: ['icon'],
}
</script>

<style lang="scss" scoped>
.action-button {
  margin-right: 10px;
  &:last-child {
    margin-right: 0px;
  }

  & > i {
    font-style: normal;
    background: #e1e9ff;
    border-radius: 6px;
    font-weight: normal;
    font-size: 15px;
    line-height: 15px;
    color: #3699ff;
    padding: 8px;
  }
}
</style>